






















import Vue from "vue";
import SelectList from "@/components/shared/SelectList.vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroPlayerDocument } from "../../../../services/datatypes";
import { db, firestore } from "@/scripts/firebase";
import { collectionName } from "../../../../services/collection-name";

@Component({
  components: {
    SelectList,
  },
})
export default class Uranaishi extends Vue {
  @Prop() readonly jinroGameId!: string;
  selectedPlayer: JinroPlayerDocument | null = null;

  get selectLabel(): string {
    return "あなたは誰を占いたいですか";
  }

  get selectablePlayers(): Array<JinroPlayerDocument> {
    if (this.$store.state.jinroPlayerGame) {
      return this.$store.state.jinroPlayerGame.uranaishiSelectablePlayers;
    } else {
      return [];
    }
  }
  get submittedPlayerName(): string {
    if (
      !this.$store.state.jinroPlayerGame ||
      !this.$store.state.jinroPlayerGame.uranaishiSelectedPlayer
    ) {
      return "";
    }
    return this.$store.state.jinroPlayerGame.uranaishiSelectedPlayer.playerName;
  }

  get hasSubmited(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      return !!this.$store.state.jinroPlayerGame.uranaishiSelectedPlayer;
    } else {
      return false;
    }
  }

  async handleCancelSubmit() {
    await this.refJinroPlayerJinroGame.set(
      {
        uranaishiSelectedPlayer: firestore.FieldValue.delete(),
        timeUpdated: firestore.FieldValue.serverTimestamp(),
      },
      {
        merge: true,
      }
    );
    return;
  }

  async handleSubmit(selectedOption: string) {
    this.selectedPlayer = this.selectablePlayers.find((player) => {
      return player.id === selectedOption;
    }) as JinroPlayerDocument;

    // update selected Player to jinroplayinfo
    await this.refJinroPlayerJinroGame.set(
      {
        uranaishiSelectedPlayer: this.selectedPlayer,
        timeUpdated: firestore.FieldValue.serverTimestamp(),
      },
      {
        merge: true,
      }
    );
  }
  get refJinroPlayerJinroGame(): firebase.firestore.DocumentReference {
    const jinroGameId = this.$store.state.jinroGame.id;
    return db
      .collection(collectionName.jinroplayers)
      .doc(this.$route.params.jinroPlayerId)
      .collection(collectionName.jinrogames)
      .doc(jinroGameId);
  }
}
